/**
 * sophior-header.js
 * Header-gedrag (voorheen twee inline scriptblokken in
 * sections/sophior-header.liquid): mobiele navigatie, zoek-toggle,
 * cart-knop (native drawer of /cart) en mega menu-toetsenbord.
 * Geladen met defer, dus de DOM staat er als dit draait.
 */
(function () {
  /* ---- Mobiele navigatie ---- */
  var hamburger = document.querySelector('.sophior-header__hamburger');
  var mobileNav = document.getElementById('sophior-mobile-nav');
  var closeButtons = document.querySelectorAll('[data-action="close-mobile-nav"]');

  function openNav() {
    hamburger.setAttribute('aria-expanded', 'true');
    mobileNav.classList.add('sophior-mobile-nav--open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sophior-nav-open');
    /* Focus naar het paneel zodat toetsenbord/screenreader het menu in gaat */
    var firstFocusable = mobileNav.querySelector('button, a[href]');
    if (firstFocusable) firstFocusable.focus();
  }

  function closeNav() {
    if (!mobileNav) return;
    var wasOpen = mobileNav.classList.contains('sophior-mobile-nav--open');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileNav.classList.remove('sophior-mobile-nav--open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sophior-nav-open');
    /* Focus terug naar de hamburger, maar alleen als het menu echt open was */
    if (wasOpen && hamburger) hamburger.focus();
  }

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      if (hamburger.getAttribute('aria-expanded') === 'true') {
        closeNav();
      } else {
        openNav();
      }
    });

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeNav);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });
  }

  /* Mobile dropdown toggles */
  document.querySelectorAll('.sophior-mobile-nav__dropdown-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var targetId = btn.getAttribute('data-target');
      var dropdown = document.getElementById(targetId);
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.classList.toggle('sophior-mobile-nav__dropdown-toggle--open', !expanded);
      if (dropdown) {
        dropdown.setAttribute('aria-hidden', String(expanded));
        dropdown.classList.toggle('sophior-mobile-nav__dropdown--open', !expanded);
      }
    });
  });

  /* ---- Search toggle ---- */
  var searchToggle = document.querySelector('.sophior-header__search-toggle');
  if (searchToggle) {
    var searchContainer = searchToggle.closest('.sophior-header__search');
    /* Sinds P-44 staat er ook een hidden input (options[prefix]) in het
       formulier: expliciet het zoekveld pakken, niet de eerste de beste. */
    var searchInput = searchContainer ? searchContainer.querySelector('input[type="search"]') : null;
    var predictive = searchContainer ? searchContainer.querySelector('predictive-search') : null;

    var closePredictive = function (clearTerm) {
      if (predictive && typeof predictive.close === 'function') predictive.close(clearTerm === true);
    };

    searchToggle.addEventListener('click', function () {
      if (!searchContainer) return;
      searchContainer.classList.toggle('is-open');
      var isOpen = searchContainer.classList.contains('is-open');
      this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        if (searchInput) searchInput.focus();
      } else {
        /* Suggesties mogen niet open blijven hangen als het veld dichtklapt */
        closePredictive(true);
      }
    });

    /* Escape sluit eerst de suggestielijst en pas daarna de zoeklaag —
       dezelfde volgorde als Dawn's zoekmodal. */
    if (searchInput) {
      searchInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (predictive && predictive.hasAttribute('open')) {
          closePredictive(false);
          event.stopPropagation();
          return;
        }
        if (searchContainer) {
          searchContainer.classList.remove('is-open');
          searchToggle.setAttribute('aria-expanded', 'false');
          searchToggle.focus();
        }
      });
    }
  }

  /* ---- Cart button — één centrale open-flow (native drawer / /cart)
     in sophior-cart-sync.js; de header stuurt alleen het event. ---- */
  var cartBtn = document.querySelector('[data-cart-toggle]');
  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('sophior:open-cart'));
    });
  }

  /* ---- Mega menu — toetsenbord: open op focus, sluit op focus-verlies of Escape.
     Hover blijft puur CSS; .is-open spiegelt de toestand voor toetsenbord
     en houdt aria-expanded synchroon. ---- */
  var megaItems = document.querySelectorAll('.sophior-header__nav-item--mega');
  Array.prototype.forEach.call(megaItems, function (item) {
    var trigger = item.querySelector('.sophior-header__nav-link');
    if (!trigger) return;

    /* P-43: de tegelbeelden staan als data-mega-src in de HTML en laden pas
       bij de eerste opening van dit menu-item. De wrapper heeft een vaste
       1:1-box (padding-top: 100%), dus het inladen verschuift niets. */
    var imagesLoaded = false;
    function loadTileImages() {
      if (imagesLoaded) return;
      imagesLoaded = true;
      var imgs = item.querySelectorAll('img[data-mega-src]');
      Array.prototype.forEach.call(imgs, function (img) {
        var srcset = img.getAttribute('data-mega-srcset');
        if (srcset) img.setAttribute('srcset', srcset);
        img.setAttribute('src', img.getAttribute('data-mega-src'));
        img.removeAttribute('data-mega-src');
        img.removeAttribute('data-mega-srcset');
      });
    }

    function setOpen(open) {
      if (open) loadTileImages();
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    /* Escape geeft focus terug aan de trigger; die focusin mag het menu
       niet direct heropenen (anders sluit Escape nooit echt). */
    var suppressFocusOpen = false;

    item.addEventListener('mouseenter', function () { setOpen(true); });
    item.addEventListener('mouseleave', function () { setOpen(false); });
    /* Hover opent het paneel puur via CSS; op een aanraakscherm bestaat die
       hover niet, dus daar laadt de eerste aanraking de beelden. */
    item.addEventListener('touchstart', loadTileImages, { passive: true });
    item.addEventListener('focusin', function () {
      if (suppressFocusOpen) { suppressFocusOpen = false; return; }
      setOpen(true);
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        suppressFocusOpen = false;
        setOpen(false);
      }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) {
        setOpen(false);
        suppressFocusOpen = true;
        trigger.focus();
      }
    });
  });
})();

/* ---- B2B: eenmalige sessie-redirect naar de bestellijst ----
   De header rendert data-b2b-redirect alleen op de homepage, alleen voor
   ingelogde B2B-klanten en alleen als de thema-instelling aanstaat. Guard via
   een sessiecookie (zonder Max-Age, leeft één browsersessie en geldt over
   álle tabbladen; sessionStorage is per tabblad en zou bij elk nieuw tabblad
   opnieuw redirecten). Wie daarna bewust naar de homepage gaat, blijft er. */
(function () {
  /* .sophior-header is de huidige header, .sophior-nav header v2 (B6) */
  var header = document.querySelector('.sophior-header[data-b2b-redirect], .sophior-nav[data-b2b-redirect]');
  if (!header) return;
  if (document.cookie.indexOf('sophior_b2b_redirect=1') !== -1) return;
  document.cookie = 'sophior_b2b_redirect=1; path=/; samesite=lax';
  /* Alleen redirecten als de cookie echt gezet is: cookies geblokkeerd
     zou anders een redirect-loop geven */
  if (document.cookie.indexOf('sophior_b2b_redirect=1') === -1) return;
  window.location.replace(header.getAttribute('data-b2b-redirect'));
})();

/* ---- Redesign golf 1 · F0-d schil (s08-schil, D02 §3.0 en §3.2) ----
   Alleen met de body-klassen sophior-uitrol--schil-fix én --terugtrekken
   (poort). Onder 990 px schuift de header weg bij > 8 px omlaag en komt
   terug bij > 8 px omhoog; nooit boven de drempel, met menu, zoekbalk,
   lade of scroll-lock open, met toetsenbordfocus in de header of in de
   editor. Plakkende inhoud krijgt .is-stuck (schuift in CSS mee).
   Contract: html.sophior-header-hidden, --sophior-chrome-top en het event
   sophior:chrome-change { headerVisible, top }. Leest bij scrollen alleen
   scrollY (rAF); layout alleen bij init en resize. */
(function () {
  var body = document.body;
  if (!body || !body.classList.contains('sophior-uitrol--schil-fix')) return;
  if (!body.classList.contains('sophior-uitrol--terugtrekken')) return;
  if (window.__sophiorSchilInit) return;
  window.__sophiorSchilInit = true;

  var root = document.documentElement;
  var wrapper = document.querySelector('.sophior-header-section');
  /* Header v2 (B6, .sophior-nav) trekt met dezelfde schakelaars terug */
  var header = wrapper ? wrapper.querySelector('.sophior-header, .sophior-nav') : null;
  if (!header) return;

  var HIDDEN = 'sophior-header-hidden';
  var STAP = 8;
  var ONDER_HEADER = '[data-sophior-under-header], aside.facets-wrapper.page-width';
  var mobiel = window.matchMedia('(max-width: 989px)');
  /* v2: de zoeklaag staat naast de header in de wrapper (sophior-zoeklaag) */
  var zoek = header.querySelector('.sophior-header__search') || document.getElementById('sophior-zoeklaag');

  var hidden = false;
  var headerH = 0;
  var drempel = 0;
  var maxY = 0;
  var lastY = window.scrollY;
  var acc = 0;
  var ticking = false;
  var io = null;

  function setHidden(h) {
    if (h === hidden) return;
    hidden = h;
    root.classList.toggle(HIDDEN, h);
    document.dispatchEvent(new CustomEvent('sophior:chrome-change', {
      detail: { headerVisible: !h, top: h ? 0 : headerH }
    }));
  }

  /* Drempel = onderkant van de header bij scroll 0: onderkant van de sectie
     ervoor (de balk scrolt mee) plus de headerhoogte; de wrapper plakt zelf. */
  function meet() {
    headerH = header.offsetHeight;
    var boven = 0;
    var prev = wrapper.previousElementSibling;
    while (prev) {
      if (prev.classList && prev.classList.contains('shopify-section')) {
        boven = prev.getBoundingClientRect().bottom + window.scrollY;
        break;
      }
      prev = prev.previousElementSibling;
    }
    drempel = Math.max(0, boven) + headerH;
    maxY = root.scrollHeight - window.innerHeight;
  }

  /* Alleen toetsenbordfocus houdt de header vast (WCAG 2.4.11), niet de
     focus die na een tik op de hamburger blijft staan. */
  function focusInHeader() {
    var el = document.activeElement;
    if (!el || el === body || !header.contains(el)) return false;
    try {
      return el.matches(':focus-visible');
    } catch (e) {
      return true;
    }
  }

  function blokkeert() {
    if (!mobiel.matches || !headerH) return true;
    if (window.Shopify && window.Shopify.designMode) return true;
    var c = body.classList;
    if (
      c.contains('sophior-nav-open') ||
      c.contains('overflow-hidden') ||
      c.contains('overflow-hidden-mobile') ||
      c.contains('overflow-hidden-tablet')
    ) {
      return true;
    }
    if (zoek && zoek.classList.contains('is-open')) return true;
    return focusInHeader();
  }

  function verwerk() {
    ticking = false;
    var y = window.scrollY;
    /* iOS-rubberband: posities buiten het scrollbereik negeren; de pagina-
       hoogte alleen opnieuw lezen als scrollY voorbij de bewaarde grens komt */
    if (y < 0) return;
    if (y > maxY) {
      maxY = root.scrollHeight - window.innerHeight;
      if (y > maxY + 1) return;
    }
    var d = y - lastY;
    lastY = y;
    if (y <= drempel || blokkeert()) {
      acc = 0;
      setHidden(false);
      return;
    }
    if (d === 0) return;
    if ((d > 0) !== (acc > 0)) acc = 0;
    acc += d;
    if (acc > STAP) {
      setHidden(true);
    } else if (acc < -STAP) {
      setHidden(false);
    }
  }

  function opScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(verwerk);
  }

  /* .is-stuck: een element dat op de headerhoogte plakt, steekt boven de
     ingekorte root (headerhoogte + 1 px) uit en is dus niet helemaal zichtbaar. */
  function observeer() {
    if (!('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var stuck = e.intersectionRatio < 1 && e.boundingClientRect.top <= headerH + 1;
        e.target.classList.toggle('is-stuck', stuck);
      });
    }, { rootMargin: '-' + (headerH + 1) + 'px 0px 0px 0px', threshold: [1] });
    Array.prototype.forEach.call(document.querySelectorAll(ONDER_HEADER), function (el) {
      io.observe(el);
    });
  }

  function init() {
    meet();
    observeer();
    lastY = window.scrollY;
    verwerk();
  }

  window.addEventListener('scroll', opScroll, { passive: true });

  var resizeTick = false;
  window.addEventListener('resize', function () {
    if (resizeTick) return;
    resizeTick = true;
    window.requestAnimationFrame(function () {
      resizeTick = false;
      var oud = headerH;
      meet();
      if (headerH !== oud) observeer();
      verwerk();
    });
  });

  if (typeof mobiel.addEventListener === 'function') {
    mobiel.addEventListener('change', verwerk);
  } else if (typeof mobiel.addListener === 'function') {
    mobiel.addListener(verwerk);
  }

  /* Toetsenbord in de header (ook Shift+Tab terug naar boven): direct tonen */
  header.addEventListener('focusin', function () {
    if (hidden && focusInHeader()) {
      acc = 0;
      setHidden(false);
    }
  });

  /* Menu, lade of scroll-lock open terwijl de header weg is: tonen */
  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      if (hidden && blokkeert()) {
        acc = 0;
        setHidden(false);
      }
    }).observe(body, { attributes: true, attributeFilter: ['class'] });
  }

  /* D03: de beslisbalk wordt bij elke filtertik vervangen */
  document.addEventListener('sophior:collectie-gerenderd', observeer);

  /* Terug uit de bfcache: vanaf de huidige positie verder rekenen */
  window.addEventListener('pageshow', function () {
    lastY = window.scrollY;
    verwerk();
  });

  window.requestAnimationFrame(init);
})();
